import { SectionShell } from "@/components/design-system/SectionShell";
import { Toast } from "@/components/ui/toast";

const code = `import { Toast } from "@/components/ui/toast";

// The component is just the snackbar — the host positions it.
{saved && (
  <div className="fixed bottom-6 left-1/2 z-50 -translate-x-1/2">
    <Toast message="Estimate saved" />
  </div>
)}`;

export function ToastSection() {
  return (
    <SectionShell
      id="toast"
      title="Toast"
      description={
        <>
          Dark confirmation snackbar with an accent check, ported from
          FloorCore. Deliberately minimal: it renders the pill only — the
          host owns positioning, stacking, and dismiss timing.
        </>
      }
      whenToUse={
        <ul>
          <li>
            Transient confirmation after a successful mutation ("Saved",
            "Sent", "Copied").
          </li>
          <li>Feedback that needs no action from the user.</li>
        </ul>
      }
      whenNotToUse={
        <ul>
          <li>
            Errors or anything requiring a decision — use inline errors or a
            danger callout.
          </li>
          <li>Persistent status — use a badge or callout.</li>
        </ul>
      }
      preview={<Toast message="Estimate saved" />}
      code={code}
      options={
        <ul className="list-disc pl-5">
          <li>
            <code>message</code> accepts any React node.
          </li>
          <li>
            Renders with <code>role="status"</code> so screen readers
            announce it politely.
          </li>
          <li>
            In dark mode a hairline border keeps it separable from the page.
          </li>
        </ul>
      }
    />
  );
}
